module.exports = __webpack_public_path__ + "arrow.be138443.png";